import { render, staticRenderFns } from "./JurisdictionNavigation.vue?vue&type=template&id=4ba5c80b&scoped=true"
import script from "./JurisdictionNavigation.vue?vue&type=script&lang=js"
export * from "./JurisdictionNavigation.vue?vue&type=script&lang=js"
import style0 from "./JurisdictionNavigation.vue?vue&type=style&index=0&id=4ba5c80b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba5c80b",
  null
  
)

export default component.exports